export default {
    "/": {
        "title": "Taoify - Plataforma de creación de sitios web para comercio electrónico transfronterizo | Productos chinos, vendidos a nivel global",
        "desc": "Taoify integra la creación de sitios, traducción, listado, logística, pagos y marketing en un solo panel: 18 empleados AI te ayudan, tiendas en 20 idiomas, productos chinos vendidos al mundo entero."
    },
    "/feature": {
        "title": "Funciones · Todo lo que necesitas para abrir tu tienda, en una sola página · Taoify",
        "desc": "Creación de sitios, traducción, listado, envío, cobro, atracción de clientes — Taoify coloca los 15 módulos necesarios para vender internacionalmente en un solo panel, sin necesidad de usar múltiples herramientas externas."
    },
    "/ai-staff": {
        "title": "Empleados AI · 18 empleados AI, los más ocupados son los que atraen tráfico · Taoify",
        "desc": "De los 18 empleados AI, 5 del equipo de crecimiento se encargan específicamente de atraer visitantes: 12 puntos de inspección de la tienda, planes de marketing de 30 días, adaptación de un producto para 9 canales, correos electrónicos automáticos de marketing para traer de vuelta a los compradores anteriores."
    },
    "/logistics": {
        "title": "Logística transfronteriza · Desde tus manos hasta las del cliente · Taoify",
        "desc": "Transporte inicial, despacho aduanero, transporte principal, entrega final, tres rutas según el tipo de carga y tiempo. Ya conectados con YunExpress, Yanwen, 4PX, etiquetas, seguimiento y manejo de excepciones en un solo panel."
    },
    "/payment": {
        "title": "Cobros y liquidaciones · El cliente paga como le resulte más cómodo · Taoify",
        "desc": "PayPal, Stripe, tarjetas de crédito, Alipay, listos para usar. Recibe en divisas extranjeras, retira en RMB, liquidación T+7, comisiones y tiempos de llegada claros."
    },
    "/pricing": {
        "title": "Precios · Planes de suscripción + comisión escalonada · Taoify",
        "desc": "La tienda se cobra por paquetes de suscripción: Básico $15/mes, Estándar $29/mes, Premium $59/mes, ahorra más con pago trimestral o anual. La comisión por transacciones es escalonada según el volumen mensual, con un mínimo del 3%."
    },
    "/cases": {
        "title": "Casos de éxito · Están haciendo lo mismo · Taoify",
        "desc": "Vendedores de accesorios de Yiwu, 3C de Shenzhen, ropa de Guangzhou, y también de Alemania, EE. UU. y Francia — seis personas, seis orígenes, un mismo método."
    },
    "/sign-up": {
        "title": "Abrir tienda - Registro gratuito en Taoify",
        "desc": "Crea tu sitio web de marca en 10 minutos, sin código, con prueba gratuita de todas las funciones. Regístrate ahora en Taoify y comienza tu viaje en el comercio electrónico internacional."
    },
    "/for-china-sellers": {
        "title": "Para vendedores chinos · Tú seleccionas los productos y fijas los precios, nosotros nos encargamos del resto · Taoify",
        "desc": "La plataforma se encarga de la creación del sitio, traducciones, envíos, etiquetas de envío y atención al cliente. Suscríbete a nuestros paquetes + comisiones escalonadas (desde el 3%)."
    },
    "/for-global-sellers": {
        "title": "Para vendedores internacionales: Elige tus productos en los estantes chinos y vende en tu propia tienda · Taoify",
        "desc": "Sin necesidad de almacenar inventario: Selecciona productos desde la cadena de suministro china, que se enviarán directamente desde China una vez que el cliente haga su pedido. BuyLink también puede convertir enlaces de 1688 y Taobao en tus propios productos."
    },
    "/template-index": {
        "title": "Mercado de plantillas - Plantillas profesionales para sitios web de Taoify",
        "desc": "Plantillas profesionales para cualquier proyecto, con una gran variedad de diseños gratuitos para adaptar la imagen y funcionalidades de tu marca según tus necesidades."
    },
    "/question": {
        "title": "Centro de ayuda · Busca aquí primero si tienes problemas · Taoify",
        "desc": "Problemas comunes relacionados con la apertura de la tienda, diseño, listado de productos, logística, pagos, marketing y permisos de cuenta, organizados por categorías. Si no encuentras la solución, abre un ticket."
    },
    "/about-us": {
        "title": "Acerca de Taoify · Nuestra misión",
        "desc": "Taoify es una plataforma integral para vendedores transfronterizos: crea tu sitio web, traduce, publica productos, gestiona logística, recibe pagos y realiza marketing, todo desde un solo panel de control."
    },
    "/privacy-policy": {
        "title": "Política de privacidad · Taoify",
        "desc": "Cómo Taoify recopila, utiliza, almacena y protege tu información personal, así como los derechos que tienes sobre tus datos."
    },
    "/terms-service": {
        "title": "Términos de servicio · Taoify",
        "desc": "Condiciones y términos para el uso de los servicios de la plataforma Taoify: cuentas, tiendas, pedidos, pagos y distribución de responsabilidades."
    },
    "/consumer-agreement": {
        "title": "Política de reembolsos · Taoify",
        "desc": "Reglas de reembolso y servicio postventa para pedidos en la plataforma Taoify: condiciones de solicitud, plazos de procesamiento y métodos de recepción del dinero."
    },
    "/user-agreement": {
        "title": "Acuerdo de usuario · Taoify",
        "desc": "Antes de registrarte y usar Taoify, lee: Guía de registro, normas para la operación de la tienda y descripción del servicio de la plataforma."
    }
}
